<ion-content class="ion-padding">
  <div class="flex flex-col items-center p-5 gap-4">
    <h3 class="self-center">Share</h3>

    <h6 class="text-[14px] text-center font-[550]">
      Share with those you follow, and those who follow you
    </h6>

    <form [formGroup]="shareForm" class="w-full h-full">
      <ion-textarea
        fill="outline"
        labelPlacement="floating"
        label="Message"
        placeholder="Add a message..."
        mode="md"
        color="dark"
        [autoGrow]="true"
        [rows]="1"
        formControlName="messageValue"
        class="w-full rounded-md max-h-[180px] overflow-y-auto pt-1"
      ></ion-textarea>
    </form>

    <div
      id="selectedMembers"
      class="relative w-full border border-gray-300 rounded-md h-[120px] bg-white shadow-sm"
    >
      <div class="absolute -top-2 left-3 bg-white px-1">
        <label class="text-black text-xs">Selected Members</label>
      </div>

      <!-- Scrollable container for selected members -->
      <div class="flex gap-1.5 items-start overflow-x-auto h-full p-2">
        <div
          *ngFor="let member of selectedMembers"
          class="flex flex-col items-center min-w-[50px] max-w-[60px] mt-[10px]"
        >
          <div class="relative w-[50px] h-[50px]">
            <img
              class="w-full h-full rounded-full object-cover"
              [src]="
                member.icon
                  ? member.icon
                  : 'https://www.gravatar.com/avatar/?d=mp'
              "
              alt="{{ member.nickname }}'s profile"
            />
            <!-- Profile icon with remove 'X' -->
            <ion-icon
              name="close-circle"
              class="absolute top-0 right-0 text-red-500 cursor-pointer"
              (click)="removeSelectedMember(member)"
            ></ion-icon>
          </div>
          <div class="mt-1 text-xs text-center min-w-[50px] max-w-[60px]">
            {{ '@' + member.nickname }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Search Input -->
  <div class="relative w-full px-5">
    <ion-icon
      name="search-outline"
      class="absolute left-8 top-3 text-black"
    ></ion-icon>

    <ion-input
      fill="outline"
      color="dark"
      labelPlacement="floating"
      label="Search Members"
      type="text"
      mode="md"
      [(ngModel)]="searchText"
      (ionInput)="onSearchInputChange($event)"
      class="pl-[50px] h-full"
      style="--padding-start: 50px"
    ></ion-input>
  </div>

  <!-- Followers Section -->
  <div class="flex justify-between items-center py-1 mt-[10px]">
    <div class="w-full h-[3px] bg-[#E6E1D7]"></div>
    <div class="px-[5px] w-[90px]">
      <div
        class="pl-[5px] text-black text-[11px] font-bold uppercase leading-[18px] tracking-wide"
      >
        FOLLOWERS
      </div>
    </div>
  </div>
  <div class="h-[100px] px-[5px]">
    <div class="flex gap-1.5 overflow-x-auto no-scrollbar">
      <div
        *ngFor="let follower of accountLists?.followersList"
        class="flex flex-col items-center min-w-[50px] cursor-pointer"
        (click)="selectMember(follower)"
        [class.hidden]="selectedMembers.includes(follower)"
      >
        <div class="w-[50px] h-[50px]">
          <img
            class="w-full h-full rounded-full object-cover"
            [src]="
              follower.icon
                ? follower.icon
                : 'https://www.gravatar.com/avatar/?d=mp'
            "
            alt="{{ follower.nickname }}'s profile"
          />
        </div>
        <div class="mt-1 text-xs text-center">
          {{ '@' + follower.nickname }}
        </div>
      </div>
    </div>
  </div>

  <!-- Following Section -->
  <div class="flex justify-between items-center py-1">
    <div class="w-full h-[3px] bg-[#E6E1D7]"></div>
    <div class="px-[5px] w-[90px]">
      <div
        class="pl-[5px] text-black text-[11px] font-bold uppercase leading-[18px] tracking-wide"
      >
        FOLLOWING
      </div>
    </div>
  </div>
  <div class="h-[100px] px-[5px]">
    <div class="flex gap-1.5 overflow-x-auto no-scrollbar">
      <div
        *ngFor="let following of accountLists?.followingList"
        class="flex flex-col items-center min-w-[50px] cursor-pointer"
        (click)="selectMember(following)"
        [class.hidden]="selectedMembers.includes(following)"
      >
        <div class="w-[50px] h-[50px]">
          <img
            class="w-full h-full rounded-full object-cover"
            [src]="
              following.icon
                ? following.icon
                : 'https://www.gravatar.com/avatar/?d=mp'
            "
            alt="{{ following.nickname }}'s profile"
          />
        </div>
        <div class="mt-1 text-xs text-center min-w-[50px] max-w-[60px]">
          {{ '@' + following.nickname }}
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row w-full items-center gap-[20px] px-[10px]">
    <ark-button type="secondary" class="w-1/2" (click)="closeModal()"
      >Cancel</ark-button
    >
    <ark-button
      rightIcon="system-upload"
      class="w-1/2"
      (click)="share()"
      [disabled]="selectedMembers.length <= 0"
      >SHARE</ark-button
    >
  </div>
</ion-content>
